import React from 'react';
import Chip from '@mui/material/Chip';
import { alpha } from '@mui/material/styles';

const getCompanyLogoUrl = (logo) => (
  typeof logo === 'string' ? logo : logo?.downloadUrl || ''
);

const CompanyCell = ({ company }) => {
  const logoUrl = getCompanyLogoUrl(company?.logo);

  return (
    <Chip
      size="small"
      label={<div className='d-flex align-items-center'>
        {!!logoUrl && (
          <img
            src={logoUrl}
            alt={`${company.name}-company-logo`}
            style={{
              width: '30px',
              height: '30px',
              objectFit: 'contain',
              borderRadius: '8px',
              border: '1px solid var(--color-border)',
              backgroundColor: 'var(--color-surface)',
              padding: '2px',
              marginRight: '8px',
            }}
          />
        )}
        <span>{company?.name}</span>
      </div>}
      variant="outlined"
      sx={{
        height: 'auto',
        fontWeight: 500,
        backgroundColor: alpha(company.color, 0.05),
        borderColor: company.color,
        '& .MuiChip-label': {
          paddingTop: '4px',
          paddingBottom: '4px',
        },
      }}
    />
  );
};

export default CompanyCell;
